<template>
  <!-- <MeasuresOverview /> -->
  <ActionsOverview />
</template>

<script lang="ts">
import Vue from "vue";
import MeasuresOverview from "@/components/measures/container/MeasuresOverview.vue";
import ActionsOverview from "@/components/measures/container/ActionsOverview.vue";
export default Vue.extend({
  components: {
    // MeasuresOverview,
    ActionsOverview,
  },
});
</script>
